import React from 'react';
import { ClientApiProps } from '../../common';
import { Documentation, msalGetToken } from '../../api';
import { Header } from 'acma-spa/dist/layout/Header';

export interface AssessorDocumenationProps extends ClientApiProps {
  documenation: Documentation[];
}

export const AssessorDocumenation: React.FC<AssessorDocumenationProps> = ({ documenation, ...props }) => {
  if (documenation.length == 0) {
    return <></>;
  }

  const download = async (fileName?: string) => {
    const token = await msalGetToken(props.b2cDomainName, props.msalClient);
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    const request: RequestInit = {
      headers,
      method: 'GET',
    };

    const response = await fetch(`${props.baseUrl}/api/Operator/documentation/${fileName}`, request);

    if (response.status !== 200) {
      throw new Error(`Error downloading ${fileName} file`);
    }

    const blob = await response.blob();

    // A trick to force a download.
    // Create a link (anchor) to a file => Call its OnClick function => Destroy the link.
    const objectUrl = window.URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', fileName!);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  };

  return (
    <>
      <Header label="Examination paper" />
      <p></p>
      <p>Exam papers are replaced every 3 months. Ensure you use the up-to-date version.</p>
      <ul className="list-unstyled mt-2 mb-4">
        {documenation.map((r, i) => (
          <li key={i}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                download(r.fileName);
              }}>
              {r.fileName}
            </a>
            {r.title ? <span>{` - ${r.title}`}</span> : <></>}
          </li>
        ))}
      </ul>
    </>
  );
};
